import axios from 'axios';

export const getSettings = async (baseUrl, token) => {
  try {
    const response = await axios.get(`${baseUrl}user_api/setting`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.results;
  } catch (error) {
    console.error('Error fetching settings data:', error);
    return null;
  }
};
